import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MdwEmojiDetails, MdwEmojiPanel } from '@spaces-ui/meadow/components/emojis';
import { MdwEmoji } from '@spaces-ui/meadow/components/emojis/models';

import { Sample } from '../../components';

@Component({
  selector: 'app-emojis',
  templateUrl: './emojis.html',
  styleUrls: ['./emojis.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MdwEmojiDetails, MdwEmojiPanel, Sample],
})
export class Emojis {
  public selectedEmoji?: MdwEmoji;

  public handleEmojiSelect(emoji: MdwEmoji) {
    this.selectedEmoji = emoji;
  }
}
